import { Header } from '1-project/Header/Header';
import { Footer } from '1-project/Footer/Footer';
import { UI_Layout } from 'ui/components/4-habitats/Layout/Layout';
import { useRouter } from 'next/router';
import { PageProps } from '3-foundation/Types/page/pageProps';
import { PropsWithChildren } from 'react';
import Image from 'next/image';
import { HeadRegion } from '1-project/HeadRegion/HeadRegion';
import { Archivo, IBMPlexSans, IBMPlexSerif, Inter, NotoSerif, Rubik, Sen, TitilliumWeb } from '../../../styles/fonts';

type NextImageProps = React.ComponentProps<typeof Image>;

const ImageOptimization = (props: NextImageProps) => {
	return <Image {...props} alt={props?.alt ?? ''} />;
};

export const Layout = ({ children, content, site }: PageProps & PropsWithChildren) => {
	const { page, footer } = content ?? {};
	const router = useRouter();
	const siteThemes = site?.settings?.theme?.content;

	const camelToKebab = (str: string) => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

	const themeCssVars = (themes: Content.ThemeSettings['content']) =>
		themes ? Object.fromEntries(Object.entries(themes).map(([key, value]) => [`--${camelToKebab(key)}`, value])) : {};

	const toClass = (font: string) => {
		return font?.replace(/ /g, '-').toLowerCase();
	};

	const fontStyle = {
		'--font-inter': Inter.style.fontFamily,
		'--font-titillium': TitilliumWeb.style.fontFamily,
		'--font-sen': Sen.style.fontFamily,
		'--font-rubik': Rubik.style.fontFamily,
		'--font-notoserif': NotoSerif.style.fontFamily,
		'--font-ibmplexsans': IBMPlexSans.style.fontFamily,
		'--font-ibmplexserif': IBMPlexSerif.style.fontFamily,
		'--font-archivo': Archivo.style.fontFamily,
		// Set primary font as body font with sans-serif fallback
		fontFamily: IBMPlexSans.style.fontFamily + ', sans-serif',
	} as React.CSSProperties;
	return (
		<div
			style={{ ...fontStyle, ...themeCssVars(siteThemes) }}
			className={`
            theme-font-primary--${toClass(siteThemes?.headingFont)}
            theme-font-secondary--${toClass(siteThemes?.bodyFont)}
        `}
		>
			<UI_Layout router={router} imageOptimization={ImageOptimization}>
				<HeadRegion {...page?.properties} />
				<Header desktopLogo={site?.siteDesktopLogo} mobileLogo={site?.siteMobileLogo} />
				{children}
				{footer ? <Footer footer={footer} /> : null}
			</UI_Layout>
		</div>
	);
};
